// src/redux/slices/uiSlice.js - make sure openAuthModal is exported
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: localStorage.getItem('theme') || 'light',
  sidebarCollapsed: localStorage.getItem('sidebarCollapsed') === 'true',
  activeSection: 'dashboard',
  isAuthModalOpen: false,
  authMode: 'login',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', state.theme);
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      localStorage.setItem('sidebarCollapsed', state.sidebarCollapsed);
    },
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    openAuthModal: (state) => {
      state.isAuthModalOpen = true;
    },
    closeAuthModal: (state) => {
      state.isAuthModalOpen = false;
    },
    setAuthMode: (state, action) => {
      state.authMode = action.payload;
    },
  },
});

export const {
  toggleTheme,
  toggleSidebar,
  setActiveSection,
  openAuthModal,
  closeAuthModal,
  setAuthMode,
} = uiSlice.actions;

export default uiSlice.reducer;